interface CategoryTabsProps {
  activeCategory: string
  onCategoryChange: (category: string) => void
}

const categories = [
  { id: 'trending', label: 'Trending', description: 'Most popular right now' },
  { id: 'popular', label: 'Popular', description: 'All-time favorites' },
  { id: 'top-rated', label: 'Top Rated', description: 'Highest scored anime' },
]

export function CategoryTabs({ activeCategory, onCategoryChange }: CategoryTabsProps) {
  return (
    <div className="flex flex-wrap gap-2">
      {categories.map((category) => (
        <button
          key={category.id}
          onClick={() => onCategoryChange(category.id)}
          className={`px-6 py-3 rounded-lg font-medium transition-all duration-200 ${
            activeCategory === category.id
              ? 'bg-gradient-to-r from-blue-500 to-purple-600 text-white shadow-lg'
              : 'bg-gray-800 text-gray-300 hover:bg-gray-700 hover:text-white'
          }`}
        >
          <div className="text-center">
            <div className="font-semibold">{category.label}</div>
            <div className="text-xs opacity-80">{category.description}</div>
          </div>
        </button>
      ))}
    </div>
  )
}
